import * as apiCall from '../../../axios'

let apiVersion = 'v3';

export const getReferralLink = () => {
  return apiCall.sendRequest(`/api/${apiVersion}/referral_link`)
}